import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Button from '@ux/button';
import Banner from './banner.js';

/**
 * Create implicit banner view
 *
 * @param {Visitor} visitor Page viewer for which consents are updating
 * @param {object} eids Object of events name to send events to traffic client
 * @param {object} i18n The localization strings object
 * @param {function} onClose onClose banner module open privacy manager module
 * @param {string} privacyPolicyUrl The URL to get more details about privacy policy
 * @returns {Component} The implicit banner module
 * @public
 */
export default function ImplicitBanner({ visitor, eids, i18n, onClose, privacyPolicyUrl }) {
  const [visible, setVisible] = useState(true);

  const onClickAccept = () => {
    visitor.recordInteraction({
      eid: eids.close,
      utag: true
    });

    setVisible(false);
    onClose();
  };

  const renderChoices = () => {
    return <>
      <Button id='pw_accept'
        onClick={ onClickAccept }
        design='primary'
        text={ i18n['banners.accept'] }/>

      <Button id='pw_info'
        href={ privacyPolicyUrl }
        external={ true }
        className='btn-link ux-btn-set-item'
        design='link'
        type='button'
        text={ i18n['banners.learnMore'] }
        data-eid={ eids.moreInfo } />
    </>;
  };

  return <Banner
    title={ i18n['banners.title'] }
    notice={ i18n['banners.description'] }
    visible={ visible }
    renderChoices={ renderChoices } />;
}

ImplicitBanner.propTypes = {
  visitor: PropTypes.object.isRequired,
  eids: PropTypes.objectOf(PropTypes.string).isRequired,
  i18n: PropTypes.objectOf(PropTypes.string).isRequired,
  onClose: PropTypes.func.isRequired,
  privacyPolicyUrl: PropTypes.string.isRequired
};
